// ** Graphql
import { gql } from '@apollo/client';

export const AUTH_LOGIN = gql`
  mutation ($email: String!, $password: String  ) {
    authLogin(email: $email, password: $password) {
      token
      status
      message
      response{
     punchInStatus
         menu {
        name
        status
        Subfields {
          name
          status
        }
      }
      }
    }
  }
`;
export const AUTH_RESET_PASSWORD = gql`
  mutation ($email: String!, $password: String!, $token: String!, $isPasswordGenerated: Boolean ) {
    createpassword(email: $email, password: $password, token: $token, isPasswordGenerated: $isPasswordGenerated) {
      status
      message
    }
  }
`;

export const GET_ALL_USERS = gql`
  query {
    getAllUsers {
      status
      message
      response{
        id
        firstname
        lastname
        email
        mobile
        gender
        token
        isPasswordGenerated
        clients
        department
        employeestatus
        role
        reportingManager
       
      }
    }
  }
`;

export const FETCH_ALL_USERS = gql`
  mutation($loginUserId: String) {
    fetchAllUsers (loginUserId: $loginUserId){
      status
      message
      response{
        id
        gender  
    EmpID
    role
    email
    mobile
    firstname
    lastname
    designation
    department
    reportingManager
    reportingTo
    signedIn
    employeestatus
    accessType
    image
    leavesSettings {
      department
      year
      casualLeaves
      medicalLeave
      CarryforwardLeaves
      carryFlag
      Key
    }
     client {
      NameOfClient
      processes
      role
      SlotNo
      confidentialAcess
    }
    }
    }
  }
`;



export const GET_USER_DETAILS = gql`
  mutation ($id: String!) {
    getUserDetails(id: $id) {
      id
      EmpID
      firstname
      email
      lastname
      createdTime
      designation
      department
      reportingManager
      image
      punchInStatus
      role
      clients
      employeestatus
      clientKey
      casualLeavesApplied
      casualLeavesAvailable
      medicalLeavesApplied
      medicalLeavesAvailable
      annualLeavesApplied
      annualLeavesAvailable
      DateOfJoining
      PanNumber
      PfNo
      UAN
      BankName
      BankAccountNo

      client {
        NameOfClient
        processes
        role
        SlotNo
        confidentialAcess
      }
 
      menu {
        name
        status
        Subfields {
          displayName
          name
          status
        }
      }
 
      route {
        name
        status
      }
 
      teamsReportDirect {
        reportingId
        }
        leavesSettings {
          department
          year
          casualLeaves
          medicalLeave
          CarryforwardLeaves
          carryFlag
          Key
        }
    emailSettings{
      email
      password
      status
    }  
    sharedemailSettings{
      email
      status
    }
    salesEmailSettings{
      email
      salesEmailId
      status
    }
  }
}
`;



export const GET_ALL_CLIENTS = gql`
  query {
    getAllClients {
      status
      message
      response{
        id
        clientName
       ServicesAssigned
      BlueplanitReportingLead
        department
        timeZone
        status
        emailId
        image
        emailId
        EditClient{
          id
         clientId
         userName
         action
         EditStatus
         changeTime
        }
      agencyName
      physicalAddress
      mailingAddress
      noOfSlots
      remarks
      InvoiceDetails {
        customerName
        fromDate
        endDate
        billingCycles
        durationType
        billStarting
        subTotal
        taxTotal
        grandTotal
        companyAddress
        accountNumber
        bankName
        bankAddress
        products {
          productId
          name
          description
          image
          tax
          price
          qty
          type
          billingPeriod
        } 
      }
      GeneratedInvoices{
        subscriptionIndex
        invoiceNo
        invoiceDate    
        dueDate
        invoiceImage
        subTotal
        taxTotal
        grandTotal
      }
      }
    }
  }
`;

export const GET_ALL_INSURANCE_CARRIERS = gql`
  query {
    getAllInsuranceCarriers {
      status
      message
      response{
        id
        carrierName
        status
        userId
      }
    }
  }
`;

export const GET_ALL_CURRENT_CARRIERS = gql`
  query {
    getAllCurrentCarriers {
      status
      message
      response{
        id
        carrierName
        status
        userId
      }
    }
  }
`;

export const GET_ALL_CARRIERS = gql`
query{
getAllCarriers{
 status
 message
 response {
        id
        userId
        carrierName
        status
        flag
      }
}
}
`
export const UPDATE_USER_ACCESS_TYPE = gql`
  mutation UpdateEmployeeAccessType($id: String!, $accessType: [String]!) {
    updateEmployeeAccessType(id: $id, accessType: $accessType) {
      id
      accessType
      firstname
      lastname
    }
  }
`
